import 'jquery-inview';
/*
let breakPoint = 768;
let scrollPosition = $(window).scrollTop();

$(function () {

  $(window).on('load', function () {
    setTimeout(function () {
      infographicView($(window).scrollTop());
    }, 0);
  });

  $(window).on('scroll resize', function () {
    infographicView($(this).scrollTop());
    scrollPosition = $(this).scrollTop();
  });

  //  $('.lists-infographic-slides').on('touchstart', TouchStart);
  //  function TouchStart(event) {
  //    infographicView($(window).scrollTop());
  //  }

});

function infographicView(scrollTop) {
  $('.lists-infographic .sec-list.inviewCount').not('.anime-start').each(function (i) {
    let $this = $(this);
    $this.find('.countzero, .count .number, .countup').html('');
    let startY = 150;
    if ($(window).width() <= breakPoint) {
      startY = 50;
    }
    if ((scrollTop > $this.offset().top - $(window).height() + startY && scrollTop >= scrollPosition) || (scrollTop > $this.offset().top + startY / 3 && scrollTop < scrollPosition && scrollTop < $this.offset().top + $this.height() - 150)) {

      $this.addClass('anime-start');
      setTimeout(function () {
        $this.addClass('anime--start');
        $this.find('.counter').addClass('anime--fadein');
      }, 300 * (i + 1));
      setTimeout(function () {
        $this.find('.tx-number').fadeIn();
        count1($this);
      }, 500 * (i + 1));
    }
  });

}

function count1(targetID) {

  // if ($(targetID).hasClass('list-infographic1') || $(targetID).hasClass('list-infographic3') || $(targetID).hasClass('list-infographic6')) {
  //   $(targetID).find('.icons .img-icon').each(function (i) {
  //     $(this).delay(60 * i).queue(function () {
  //       $(this).addClass('icon-fadein');
  //     });
  //   });
  // }
  // if ($(targetID).hasClass('list-infographic4')) {
  //   $(targetID).find('.chart--horiz li').each(function (i) {
  //     $(this).delay(100 * i).queue(function () {
  //       $(this).addClass('bar-fadein');
  //     });
  //   });
  // }


  $(targetID).find('.countzero').each(function (i) {
    let $this = $(this);
    let tgt = $(this).data('num');
    let num = i;
    let speed = 20;
    let countset = setInterval(function () {
      $this.html(num);
      if (num == 9) {
        num = 0;
      }
      num++;
    }, speed);
    setTimeout(function () {
      $this.html(tgt);
      clearInterval(countset);
    }, 800);
  });
}



$('.lists-infographic .sec-list').each(function () {
  $(this).on('inview', function () {
    $(this).addClass('inviewCount');
  });
});

*/

let breakPoint = 768;

$(function () {
  // ページロード後に実行
  $(window).on('load', function () {
    // 初回実行
    setTimeout(function () {
      startAnimation();
    }, 0);

    // 5秒おきに繰り返し実行
    setInterval(function () {
      startAnimation();
    }, 5000);
  });
});

function startAnimation() {
  $('.lists-infographic .sec-list.inviewCount').each(function (i) {
    let $this = $(this);
    $this.find('.countzero, .count .number, .countup').html('');

    $this.addClass('anime-start');
    setTimeout(function () {
      $this.addClass('anime--start');
      $this.find('.counter').addClass('anime--fadein');
    }, 300 * (i + 1));
    setTimeout(function () {
      $this.find('.tx-number').fadeIn();
      count1($this);
    }, 500 * (i + 1));
  });
}

function count1(targetID) {
  $(targetID).find('.countzero').each(function (i) {
    let $this = $(this);
    let tgt = $(this).data('num');
    let num = i;
    let speed = 20;
    let countset = setInterval(function () {
      $this.html(num);
      if (num == 9) {
        num = 0;
      }
      num++;
    }, speed);
    setTimeout(function () {
      $this.html(tgt);
      clearInterval(countset);
    }, 800);
  });
}

// inviewClass付与（初期設定用）
$('.lists-infographic .sec-list').each(function () {
  $(this).addClass('inviewCount');
});
